// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"home","571":"settings"}[chunkId] + "." + {"177":"cfe6f0dc","571":"57faffbf"}[chunkId] + ".css";
};